import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import PropTypes from "prop-types";
import AddToCartNextSteps from "./AddToCartNextSteps";

const styles = (theme) => ({
  MuiFormControlRoot: {
    display: "flex !important",
    [theme.breakpoints.up("sm")]: {
      marginTop: 15,
      marginBottom: 20,
    },
    "& label": {
      fontSize: 15,
    },
  },
  checkboxLabel: {
    fontSize: 15,
    paddingBottom: 12,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 12,
    },
  },
  formHelperText: {
    marginLeft: 45,
    marginBottom: 15,
  },
});

const AddToCartAcceptDesign = (props) => {
  const { classes, termsApproval, onTermsApprovalChange, displayAcceptDesign } =
    props;

  const termsLink = `<a href="${t(
    "acceptDesignScreen.termsAndConditionsLinkURL"
  )}"
            target="_blank">${t(
              "acceptDesignScreen.termsAndConditionsLinkLabel"
            )}</a>`;
  const privacyLink = `<a href="${t("acceptDesignScreen.privacyLinkURL")}"
            target="_blank">${t("acceptDesignScreen.privacyLinkLabel")}</a>`;

  const termsAndConditionsText = t(
    "acceptDesignScreen.termsAndConditionsText",
    { termsLink, privacyLink }
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <AddToCartNextSteps />
      </Grid>

      {displayAcceptDesign && (
        <Grid item xs={12}>
          <FormControlLabel
            className={classes.checkboxLabel}
            control={
              <Checkbox
                name="approvalTermsAndConditions"
                checked={termsApproval.value}
                onChange={onTermsApprovalChange}
                color="primary"
              />
            }
            label={
              <span
                dangerouslySetInnerHTML={{
                  __html: termsAndConditionsText,
                }}
              />
            }
          />
          {termsApproval.error && (
            <FormHelperText error={true} className={classes.formHelperText}>
              {t("acceptDesignScreen.selectionError")}
            </FormHelperText>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default withWidth()(
  withStyles(styles, { name: "AddToCartAcceptDesign" })(AddToCartAcceptDesign)
);
